const d = 'm196-28 75-324L19-570l332-28 129-306 129 306 332 28-252 218 76 324-285-173L196-28Z';

export default d;
